import * as React from "react";

export function PageHero({
  eyebrow,
  title,
  description,
  children,
}: {
  eyebrow?: string;
  title: string;
  description?: string;
  children?: React.ReactNode;
}) {
  return (
    <section className="relative overflow-hidden border-b border-border/60">
      <div className="absolute inset-0 bg-hero-glow" aria-hidden="true" />
      <div className="relative mx-auto max-w-4xl px-4 py-14 sm:px-6 sm:py-20">
        {eyebrow ? (
          <span className="inline-flex items-center rounded-full border border-border/70 bg-surface/60 px-3 py-1 text-xs uppercase tracking-widest text-muted-foreground backdrop-blur">
            {eyebrow}
          </span>
        ) : null}
        <h1 className="mt-5 font-display text-4xl leading-tight text-foreground sm:text-5xl">
          {title}
        </h1>
        {description ? (
          <p className="mt-4 max-w-2xl text-base leading-relaxed text-muted-foreground">
            {description}
          </p>
        ) : null}
        {children ? <div className="mt-8">{children}</div> : null}
      </div>
    </section>
  );
}

export function Prose({ children }: { children: React.ReactNode }) {
  return (
    <div className="mx-auto max-w-3xl space-y-8 px-4 py-14 sm:px-6">{children}</div>
  );
}

export function ProseSection({
  title,
  children,
}: {
  title: string;
  children: React.ReactNode;
}) {
  return (
    <section className="space-y-3">
      <h2 className="font-display text-2xl text-foreground">{title}</h2>
      <div className="space-y-3 text-sm leading-relaxed text-muted-foreground">{children}</div>
    </section>
  );
}
